import { useMemo } from "react";
import { useToast, UseToastOptions } from "@chakra-ui/react";
import { capitalize } from "lodash";

type ToastHelpers = {
  [K in UseToastOptions["status"] as `notify${Capitalize<K>}`]: (
    options?: Omit<UseToastOptions, "status">
  ) => string | number;
};

const STATUSES: UseToastOptions["status"][] = [
  "info",
  "warning",
  "success",
  "error",
];

const DEFAULT_OPTIONS: UseToastOptions = {
  position: "top-right",
  duration: 4000,
  isClosable: true,
};

const DEFAULT_BASE_OPTIONS = {};

const useNotification = (baseOptions?: UseToastOptions) => {
  const toast = useToast();

  const toastHelpers = useMemo(
    () =>
      Object.fromEntries(
        STATUSES.map((status) => [
          `notify${capitalize(status)}`,
          (options = {}) =>
            toast({
              id: `notification-${status}`,
              ...DEFAULT_OPTIONS,
              ...(baseOptions || DEFAULT_BASE_OPTIONS),
              ...options,
              status,
            }),
        ])
      ) as ToastHelpers,
    [baseOptions]
  );

  return toastHelpers;
};

export default useNotification;
